import {createAction, props} from '@ngrx/store';
import {CategoryPagedResponse, CategoryTreeResponse} from '@app/marketplace/categories/_models/category.interface';

export const LIST_CATEGORIES = '[CATEGORIES] List categories';
export const LIST_CATEGORIES_SUCCESS = '[CATEGORIES] List categories success';
export const LIST_CATEGORIES_FAILURE = '[CATEGORIES] List categories failure';
export const CANCEL_CATEGORIES_REQUEST = '[CATEGORIES] Cancel categories request';
export const LIST_PRODUCTS_BY_CATEGORIES = '[CATEGORIES] List products by category';
export const CLEAR_CATEGORY_FILTER= '[CATEGORIES] Clear category filter';

//export const LOAD_CATEGORY_CODE = 'CATEGORIES Load category code by url';
/* export const LoadCategoryCodeActions = createAction(
  LOAD_CATEGORY_CODE,
  props<{categoryCode: string}>()
); */

export const ListCategories = createAction(
  LIST_CATEGORIES,
  props<{payload: any}>()
);
export const ListCategoriesSuccess = createAction(
  LIST_CATEGORIES_SUCCESS,
  props<{data: CategoryPagedResponse}>()
);
export const ListProductsByCategory = createAction(
  LIST_PRODUCTS_BY_CATEGORIES,
  props<{code: string, name: string}>()
);
export const CancelRequestCategories = createAction(CANCEL_CATEGORIES_REQUEST);
export const ListCategoriesFailure = createAction(LIST_CATEGORIES_FAILURE);
export const ClearCategoryFilter = createAction(CLEAR_CATEGORY_FILTER);


